import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from '../../modules';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import {
  Vendor,
  VendorType,
  deleteVendorAsync,
  getVendorListAsync,
} from '../../modules/vendors';
import { Alert, Col, Row, Spin, Tabs } from 'antd';
import VendorDetailDrawer from './VendorDetailDrawer';
import VendorCreateDrawer from './VendorCreateDrawer';
import TabPane from 'antd/lib/tabs/TabPane';
import VendorCompanyListComponent from '../../components/vendors/VendorCompanyListComponent';
import Title from 'antd/lib/typography/Title';
import VendorWorkerListComponent from '../../components/vendors/VendorWorkerListComponent';
import VendorCompanyBulkUploadModal from '../../components/vendors/VendorCompanyBulkUploadModal';
import { createVendors } from '../../api/constlink';
import VendorWorkerBulkUploadModal from '../../components/vendors/VendorWorkerBulkUploadModal';

interface VendorListMatchParams {
  enterpriseId: string;
}

function VendorListContainer({
  match,
}: RouteComponentProps<VendorListMatchParams>) {
  const { enterpriseId } = match.params;
  const { data, loading, error } = useSelector(
    (state: RootState) => state.vendors.vendors,
  );
  const [visibleCreateDrawer, setVisibleCreateDrawer] =
    useState<boolean>(false);
  const [detailDrawerConfig, setDetailDrawerConfig] = useState<any>();
  const [visibleDetailDrawer, setVisibleDetailDrawer] =
    useState<boolean>(false);
  const [vendorType, setVendorType] = useState<any>();

  const [
    visibleVendorCompanyBulkUploadModal,
    setVisibleVendorCompanyBulkUploadModal,
  ] = useState<boolean>(false);
  const [
    visibleVendorWorkerBulkUploadModal,
    setVisibleVendorWorkerBulkUploadModal,
  ] = useState<boolean>(false);

  const [companyList, setCompanyList] = useState<Vendor[]>([]);
  const [workerList, setWorkerList] = useState<Vendor[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (data === null) return;
    setCompanyList(data.filter((val) => val.type === VendorType.COMPANY));
    setWorkerList(data.filter((val) => val.type === VendorType.WORKER));
  }, [data]);

  useEffect(() => {
    dispatch(getVendorListAsync.request({ enterpriseId }));
  }, [dispatch, enterpriseId]);

  const onDeleteVendor = (vendorId: string) => {
    dispatch(deleteVendorAsync.request({ enterpriseId, vendorId }));
  };

  const moveToCreatePage = (vendorType: VendorType, menuType: string) => {
    if (menuType === '1') {
      setVisibleCreateDrawer(true);
      setVendorType(vendorType);
    } else if (menuType === '2') {
      if (vendorType === VendorType.COMPANY)
        setVisibleVendorCompanyBulkUploadModal(true);
      else if (vendorType === VendorType.WORKER)
        setVisibleVendorWorkerBulkUploadModal(true);
    }
  };

  const moveToDetailPage = (vendorId: number) => {
    setDetailDrawerConfig({ enterpriseId, vendorId });
    setVisibleDetailDrawer(true);
  };

  const onCloseVendorDetailDrawer = () => {
    setVisibleDetailDrawer(false);
  };

  const onCloseVendorCreateDrawer = () => {
    setVisibleCreateDrawer(false);
    // setVendorType(null);
  };

  const onCreateVendorBulkUpload = async (data: any) => {
    for (let i = 0; i < data.vendors.length; i++) {
      if (data.vendors[i].type === VendorType.WORKER) {
        data.vendors[i].application.general.jobLevel =
          data.vendors[i].application.general.jobLevel === '기공'
            ? '1'
            : data.vendors[i].application.general.jobLevel === '조공'
            ? '2'
            : '';
        data.vendors[i].application.general.wageForm =
          data.vendors[i].application.general.wageForm === '일당'
            ? '1'
            : data.vendors[i].application.general.wageForm === '프리랜서'
            ? '2'
            : '';
      }
    }
    await createVendors({ enterpriseId, data: data.vendors });
    dispatch(getVendorListAsync.request({ enterpriseId }));
    setVisibleVendorCompanyBulkUploadModal(false);
    setVisibleVendorWorkerBulkUploadModal(false);
  };

  const _onSearch = (values: any, vendorType: VendorType) => {
    if (data === null) return;
    if (vendorType === VendorType.COMPANY) {
      if ('name' in values && values.name !== undefined && values.name !== '') {
        setCompanyList(
          data
            .filter((val) => val.type === VendorType.COMPANY)
            .filter((val) =>
              val.application.general.name.includes(values.name),
            ),
        );
      } else {
        setCompanyList(data.filter((val) => val.type === VendorType.COMPANY));
      }
    } else if (vendorType === VendorType.WORKER) {
      if ('name' in values && values.name !== undefined && values.name !== '') {
        setWorkerList(
          data
            .filter((val) => val.type === VendorType.WORKER)
            .filter((val) =>
              val.application.general.name.includes(values.name),
            ),
        );
      } else {
        setWorkerList(data.filter((val) => val.type === VendorType.WORKER));
      }
    }
  };

  return (
    <>
      <Row>
        <Col flex={1}>
          <Title level={3}>거래처 관리</Title>
        </Col>
      </Row>
      {error && (
        <Alert
          message={`${error.response?.data.message}`}
          type="error"
          showIcon
          closable
        />
      )}
      {loading && (
        <Row justify={'center'}>
          <Col>
            <Spin />
          </Col>
        </Row>
      )}

      <Tabs destroyInactiveTabPane>
        <TabPane tab="사업자" key="1">
          {companyList && (
            <VendorCompanyListComponent
              moveToCreatePage={moveToCreatePage}
              onDelete={onDeleteVendor}
              moveToDetailPage={moveToDetailPage}
              onSearch={_onSearch}
              data={companyList}
            />
          )}
        </TabPane>
        <TabPane tab="작업자" key="2">
          {workerList && (
            <VendorWorkerListComponent
              moveToCreatePage={moveToCreatePage}
              onDelete={onDeleteVendor}
              moveToDetailPage={moveToDetailPage}
              onSearch={_onSearch}
              data={workerList}
            />
          )}
        </TabPane>
      </Tabs>

      {detailDrawerConfig && (
        <VendorDetailDrawer
          config={detailDrawerConfig}
          visible={visibleDetailDrawer}
          onClose={onCloseVendorDetailDrawer}
        />
      )}

      <VendorCreateDrawer
        enterpriseId={enterpriseId}
        visible={visibleCreateDrawer}
        vendorType={vendorType}
        onClose={onCloseVendorCreateDrawer}
      />
      {visibleVendorCompanyBulkUploadModal && (
        <VendorCompanyBulkUploadModal
          visible={visibleVendorCompanyBulkUploadModal}
          onCancel={() => setVisibleVendorCompanyBulkUploadModal(false)}
          onCreate={onCreateVendorBulkUpload}
        />
      )}
      {visibleVendorWorkerBulkUploadModal && (
        <VendorWorkerBulkUploadModal
          visible={visibleVendorWorkerBulkUploadModal}
          onCancel={() => setVisibleVendorWorkerBulkUploadModal(false)}
          onCreate={onCreateVendorBulkUpload}
        />
      )}
    </>
  );
}

export default withRouter(VendorListContainer);
